<ng-container *ngIf="items$ | async as items">
  <div *ngIf="items.length">
    <div class="row">
      <div class="col-12">
        <div class="bg-secondary text-center text-white items-count mb-3">
          <div class="row">
            <div class="col-10" *ngSubscribe="totalItems$ as totalItems">
              <h4 class="font-size-14 m-0 py-2 pl-5">
                <span>{{ totalItems }} ITEM<span *ngIf="totalItems > 1">S</span> IN BASKET</span>
              </h4>
            </div>
            <div class="col-2">
              <button class="btn" (click)="closeCartModal()" attr.aria-label="{{ 'cart.close.modal.screenreader' | translate }}">
                <span class="icon icon-cancel-circle text-white font-weight-bold"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <fgb-cart-item></fgb-cart-item>
      <div class="row mb-3">
        <div class="col-6 text-left pl-4 font-size-14">
          <span class="font-weight-bold">Total Points: </span>
          {{ basketPointsTotal$ | async }}
        </div>
        <div class="col-6 text-right pr-4">
          <a
            [routerLink]="['/checkout']"
            routerLinkActive="router-link-active"
            class="px-0 py-0 rounded"
            (click)="closeCartModal()"
          >
            <button class="btn btn-success font-weight-bold w-100 dropdown-checkout-btn font-size-14">Checkout</button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!items.length">
    <div class="bg-secondary text-center text-white items-count mb-3 justify-content-between">
      <div class="row">
        <div class="col-10">
          <h4 class="font-size-14 m-0 py-2 pl-5">0 <span>ITEM IN BASKET</span></h4>
        </div>
        <div class="col-2">
          <button class="btn" (click)="closeCartModal()" attr.aria-label="{{ 'cart.close.modal.screenreader' | translate }}">
            <span class="icon icon-cancel-circle text-white font-weight-bold"></span>
          </button>
        </div>
      </div>
    </div>
    <p class="mb-3 text-center font-size-14">Your basket is empty!</p>
  </div>
</ng-container>
